<template>
  <div v-if="options.MegaMenuCategories.length > 0">
    <!-- with teaser -->
    <div class="grid-x grid-margin-x align-justify">
      <div
        :class="{ auto: withTeaser, 'medium-12': !withTeaser }"
        class="cell grid-x grid-margin-x"
      >
        <!-- menu items -->
        <ul
          v-for="(catergory, i) in options.MegaMenuCategories"
          :key="i"
          :class="{
            'medium-4': withTeaser,
            'margin-left': withTeaser || (!withTeaser && i % 5 === 0),
            'medium-2': !withTeaser,
            'column-5-width': !withTeaser
          }"
          class="cell vertical menu"
        >
          <li class="padding-category-title">
            <div class="link-item mega-menu-link category-title" v-html="catergory.Title" />
          </li>
          <li v-for="(link, index) in catergory.Links" :key="'link-' + index">
            <a
              :href="link ? link.Url : ''"
              class="mega-menu-link hover-effekt"
              v-html="link.Text"
            />
          </li>
        </ul>
      </div>
      <div v-if="withTeaser" class="cell medium-4 image-padding">
        <div class="grid-y hand" @click="goToPage(options.TeaserLink)">
          <div v-if="options.TeaserImage" class="padding-bottom">
            <img
              v-if="!isExperienceEditor"
              :src="options.TeaserImage.Url"
              :alt="options.TeaserImage.Alt"
              class="cell"
            />
            <div v-else class="cell" v-html="options.TeaserImage.EditorField" />
          </div>
          <a
            v-if="options.TeaserTitle"
            :href="options.TeaserLink.Url"
            class="cell h3 no-decorations"
            v-html="options.TeaserTitle"
          />
          <div v-if="options.TeaserBody" class="cell" v-html="options.TeaserBody" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderBaseMixinVue from '../HeaderBaseMixin.vue';
import { hasProperty } from '@/common/Util/utility';

export default {
  name: 'MegaMenuPage',
  mixins: [HeaderBaseMixinVue],
  props: {
    options: {
      default() {
        return {};
      },
      type: Object
    }
  },
  computed: {
    withTeaser() {
      return this.options.MegaMenuCategories.length <= 3 && !!this.options.TeaserTitle;
    }
  },
  methods: {
    goToPage(page) {
      if (page && hasProperty(page, 'Url')) {
        window.location.assign(page.Url);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../header.scss';

.padding-category-title {
  padding: 0.7rem 1rem;
}

.no-decorations {
  text-decoration-line: none;
}

.image-padding {
  padding-top: rem-calc(22.5px);
}

.margin-left {
  margin-left: 0;
}

.column-5-width {
  width: 20% !important;
}

.category-title {
  font-size: 20px;
  font-weight: bold;
}

.hand {
  cursor: pointer;
}
</style>
